import { API_AUTH_REGISTRATION_START } from '@/shared/constants/bff-endpoints';
import type { StartRegistrationPayload, StartRegistrationResponse } from '../model/start-registration-payload';


export async function startRegistration (
    payload: StartRegistrationPayload,
): Promise<StartRegistrationResponse> {
    try {
        const response = await fetch(API_AUTH_REGISTRATION_START, {
            method : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body   : JSON.stringify(payload),
        });

        return await response.json() as StartRegistrationResponse;
    }
    catch (e) {
        const error = e instanceof Error ? e.message : 'Registration failed';
        return { ok: false, error };
    }
}
